import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from './primitives';

export function Switch({
  checked,
  onCheckedChange,
  id,
  disabled,
  label,
}: {
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  id?: string;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <SwitchPrimitive.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={label}
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-line-strong transition-colors',
        'data-[state=checked]:border-pine data-[state=checked]:bg-pine data-[state=unchecked]:bg-surface-2 disabled:opacity-50',
      )}
    >
      <SwitchPrimitive.Thumb className="block h-4.5 w-4.5 translate-x-0.5 rounded-full bg-surface shadow transition-transform data-[state=checked]:translate-x-[1.375rem] rtl:data-[state=checked]:-translate-x-[1.375rem]" />
    </SwitchPrimitive.Root>
  );
}
